import { createPortal } from 'react-dom';



import {
  Notification,
  NotificationId,
  NotificationItem,
  NotificationType,
} from './Notification';
import { useNotificationsStore } from 'app/hooks/useNotificationStore';

export type NotificationItemProps = Omit<NotificationItem, 'id' | 'variant'> & {
  id?: NotificationId;
  variant?: NotificationType;
};

export const Notifications = () => {
  const notifications = useNotificationsStore(state => state.notifications);

  if (notifications.size === 0) return null;

  return createPortal(
    <div className="fixed right-10 top-[var(--header-height)] z-[999999] flex w-[342px] select-none flex-col gap-5 mobile:right-[calc(50vw-171px)]">
      {[...notifications.values()].map(notification => (
        <Notification key={notification.id} notification={notification} />
      ))}
    </div>,
    document.body,
  );
};
